import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { XCircle, Mail } from 'lucide-react';

/**
 * Friendly cancel page — the prospect hit "Back" on Stripe Checkout.
 * No backend call needed; we simply explain what to do next.
 */
export default function PaymentCancelPage() {
  const [params] = useSearchParams();
  const requestId = params.get('request_id') || '';

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 py-12 bg-gradient-to-br from-slate-50 to-amber-50"
      data-testid="payment-cancel-page"
    >
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
        <div className="bg-gradient-to-r from-amber-500 to-orange-500 text-white px-7 py-5">
          <h1 className="text-xl font-semibold">Local Flyer Delivery</h1>
          <p className="text-xs text-white/90 mt-1">Payment cancelled</p>
        </div>
        <div className="px-7 py-8 text-center">
          <div className="mx-auto w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center">
            <XCircle size={36} className="text-amber-600" />
          </div>
          <h2 className="mt-5 text-2xl font-bold text-gray-900">Payment cancelled</h2>
          <p className="text-sm text-gray-600 mt-2 leading-relaxed">
            Your card was not charged. Your delivery request is still on file.
          </p>
          <p className="text-sm text-gray-600 mt-4 leading-relaxed">
            You can re-open the secure Stripe payment link from the most recent
            email we sent you whenever you are ready to complete payment.
          </p>
          <a
            href="mailto:info@localflyerdelivery.com"
            className="mt-6 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-lg bg-purple-600 hover:bg-purple-700 text-white font-semibold text-sm transition-colors"
            data-testid="payment-cancel-contact-btn"
          >
            <Mail size={16} /> Email Us a Question
          </a>
          {requestId && (
            <p className="text-[11px] text-gray-400 mt-6">Ref: {requestId}</p>
          )}
        </div>
      </div>
    </div>
  );
}
